/**
 * Boot.
 *
 * `StrictMode` is deliberate: it double-invokes effects in development, which is
 * what caught the account provider writing entitlements back after a sign-out
 * while that was being built. The guard against that is in `AuthProvider`.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import './index.css';

const container = document.getElementById('root');

if (container === null) {
  // index.html ships the element, so this cannot happen in a served build. Failing
  // loudly beats `!` here: a null container renders an empty page that looks like a
  // bug in the app rather than in the document.
  throw new Error('#root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
